import styled from 'styled-components';
import ds from 'designsystem';

const DebugOptionLabel = styled.label`
  cursor: pointer;
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.bold')};
  padding-right: ${ds.get('metrics.xs')};
`;

export default DebugOptionLabel;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionLabel.jsx